import { Card } from "antd";
import {
  DollarOutlined,
  WalletOutlined,
  BankOutlined,
  CalculatorOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

function ExcursionBusesExpandableDetail({ record }) {
  const { paymentResume } = record;

  const formatCurrency = (value) => {
    if (typeof value === "number") {
      return `$${value.toLocaleString("es-AR")}`;
    }
    return value || "$0";
  };

  return (
    <div className="space-y-3">
      <span className="font-bold text-md block mb-2">Resumen Financiero</span>

      {/* Grid de montos */}
      <div className="grid grid-cols-2 gap-2">
        <Card size="small" className="bg-red-50 border-red-200">
          <div className="flex items-center gap-2">
            <DollarOutlined className="text-red-500" />
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Total Gastado</span>
              <span className="font-semibold text-red-600">
                {formatCurrency(paymentResume.totalExpensesIncomeAmount)}
              </span>
            </div>
          </div>
        </Card>

        <Card size="small" className="bg-green-50 border-green-200">
          <div className="flex items-center gap-2">
            <WalletOutlined className="text-green-500" />
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Cobrado por guía</span>
              <span className="font-semibold text-green-600">
                {formatCurrency(paymentResume.totalPaymentsAmount)}
              </span>
            </div>
          </div>
        </Card>

        <Card size="small" className="bg-purple-50 border-purple-200">
          <div className="flex items-center gap-2">
            <BankOutlined className="text-purple-500" />
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Rendido por Coord.</span>
              <span className="font-semibold text-purple-600">
                {formatCurrency(paymentResume.extraIncomesAmount)}
              </span>
            </div>
          </div>
        </Card>

        <Card size="small" className="bg-orange-50 border-orange-200">
          <div className="flex items-center gap-2">
            <CalculatorOutlined className="text-orange-500" />
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Total a rendir</span>
              <span className="font-bold text-orange-600">
                {formatCurrency(paymentResume.finalAmount)}
              </span>
            </div>
          </div>
        </Card>
      </div>

      {/* Observación si existe */}
      {record.observation && (
        <Card size="small" className="bg-gray-50 border-gray-200">
          <div className="flex items-start gap-2">
            <InfoCircleOutlined className="text-gray-400 mt-0.5" />
            <div className="flex flex-col">
              <span className="text-xs text-gray-500">Observación</span>
              <span className="text-gray-700 text-sm">{record.observation}</span>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
}

export default ExcursionBusesExpandableDetail;
